module.exports = __webpack_public_path__ + "img/prize-03.abe63c3e.png";